"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const Sentry = __importStar(require("@sentry/react"));
const tracing_1 = require("@sentry/tracing");
class ReactSentryLogger {
    constructor(apiKey) {
        this.apiKey = apiKey;
    }
    /**
     * Sentry API initialization
     * @returns true or false depending on init completed or not
     */
    initWrapper() {
        Sentry.init({
            dsn: this.apiKey,
            integrations: [new tracing_1.Integrations.BrowserTracing()],
            tracesSampleRate: 1.0,
        });
        return Sentry.getCurrentHub().getClient() !== undefined;
    }
    /**
     * Writes manually a info message
     * @param message error message
     * @param severity type of error defined by TSeverity
     * @param data optional object with additional information
     */
    writeLog(message, severity, data) {
        Sentry.withScope(function (scope) {
            scope.setLevel(Sentry.Severity.fromString(severity));
            if (data)
                scope.setExtra("data", data);
            if (message instanceof Error)
                Sentry.captureException(message);
            else
                Sentry.captureMessage(message);
        });
    }
    /**
     * Defines the beginning of a snipped code execution
     * @param name transaction name
     */
    startTransaction(name) {
        if (!name)
            return;
        const transactions = {};
        transactions[name] = Sentry.startTransaction({
            name: name
        });
        globalThis.transactions = Object.assign(Object.assign({}, globalThis.transactions), transactions);
    }
    /**
     * Defines the end of a snipped code execution
     * @returns ITransaction object
     */
    finishTransaction(name) {
        if (!globalThis.transactions || !globalThis.transactions[name])
            return;
        const currentTransaction = globalThis.transactions[name];
        currentTransaction.finish();
        const transaction = {
            name: currentTransaction.name,
            startTimestamp: currentTransaction.startTimestamp,
            endTimestamp: currentTransaction.endTimestamp,
            executionTime: currentTransaction.endTimestamp - currentTransaction.startTimestamp
        };
        delete globalThis.transactions[name];
        return transaction;
    }
}
exports.default = ReactSentryLogger;
//# sourceMappingURL=ReactSentryLogger.js.map